import { useIdleTimer, type ITimers } from "react-idle-timer";

const DEFAULT_IDLE_MINUTES = 30;
const SESSION_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "touchstart",
  "scroll",
] as const;

export interface SessionTimeoutOptions {
  readonly authenticated: boolean;
  readonly onTimeout: () => void;
  readonly timeoutMinutes?: number;
  /** Fires this long before `onTimeout`. While prompted, activity events no
   *  longer reset the timer -- only the returned `activate()` does. */
  readonly promptBeforeIdleMs?: number;
  readonly onPrompt?: () => void;
  /** Injectable to keep the worker-timer implementation deterministic in tests. */
  readonly timers?: ITimers;
}

export function useSessionTimeout({
  authenticated,
  onTimeout,
  timeoutMinutes = DEFAULT_IDLE_MINUTES,
  promptBeforeIdleMs,
  onPrompt,
  timers,
}: SessionTimeoutOptions) {
  return useIdleTimer({
    disabled: !authenticated,
    timeout: timeoutMinutes * 60_000,
    onIdle: onTimeout,
    events: [...SESSION_EVENTS],
    eventsThrottle: 200,
    crossTab: true,
    syncTimers: 1_000,
    ...(promptBeforeIdleMs === undefined ? {} : { promptBeforeIdle: promptBeforeIdleMs }),
    ...(onPrompt === undefined ? {} : { onPrompt }),
    ...(timers === undefined ? {} : { timers }),
  });
}
